import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AllegatiService, UploadFile } from 'app/services/allegati.service';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-allegati-riepilogo',
  standalone: true,
  imports: [
    NgFor,
    NgIf,
    ReactiveFormsModule,
    MatIconModule,
    FormlyModule,
    AsyncPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './allegati-riepilogo.type.html',
  styleUrl: './allegati-riepilogo.type.scss'
})
export class AllegatiRiepilogoComponent extends FieldType implements OnInit {

  constructor(private _allegatiService: AllegatiService,
    private _changeDetectorRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private _fuseConfirmationService: FuseConfirmationService) {
    super()
  }

  allegati$: Observable<UploadFile[]>
  allegati: UploadFile[] = [];
  fieldName: string = 'allegati_doc_idendita'; // Assicurati che sia inizializzato correttamente

  //a
  ngOnInit(): void {
    this.allegati$ = this._allegatiService.allegati$;


    // this._allegatiService.allegati$.subscribe((x) => {
    //     for (let key in x){
    //         console.log(key)
    //         for (let i=0; i<x[key].length;i++){
    //             console.log(x[key][i].field_name)
    //             console.log(x[key][i].field_title)
    //             console.log(x[key][i].file_name)
    //             console.log(x[key][i].id)
    //         }
    //     }
    //   //this.allegati = x[this.fieldName] || []; // elenco locale per verifiche
    //   //console.log(x);
    // });
  }

  apriFile(fileId: string, filename: string = null){
    this._allegatiService.getAllegatoById(fileId).subscribe(
      (blob)=>{
        const fileUrl = URL.createObjectURL(blob);
        const iframe = document.createElement('iframe');
        iframe.src = fileUrl;
        iframe.width = '100%';
        iframe.height = '100%';
        iframe.style.border = 'none';

        const newWindow = window.open('', '_blank');
        newWindow.document.body.appendChild(iframe);
        newWindow.document.title = filename;  // alternatively 'filename.pdf'
      }
    )
  }

  scaricaFile(fileId: string, filename: string = null) {
    this._allegatiService
        .getAllegatoById(fileId)
        .subscribe((response: any) => {
            if ((window.navigator as any).msSaveBlob) {
                (window.navigator as any).msSaveBlob(response, filename);
            } else {
                let dataType = response.type;
                let binaryData = [];
                binaryData.push(response);
                let downloadLink = document.createElement('a');
                downloadLink.href = window.URL.createObjectURL(
                    new Blob(binaryData, { type: dataType })
                );
                if (filename) {
                    downloadLink.setAttribute('download', filename);
                }
                document.body.appendChild(downloadLink);
                downloadLink.click();
            }
        });
}


  trackByFn(index: number, item: UploadFile): string {
    return item.id;
  }

  trackByKey(index: number, key: string): string {
    return key;
  }

  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }



}
